// ===== Audio Manager =====
// Synthesizes discreet, copyright-free sound effects with the Web Audio API.
// Fully separate from the narrator (SpeechSynthesis) and from VoiceOver.
// Controlled by settings. No background music.

class AudioManager {
  constructor() {
    this.ctx = null;
    this.soundEnabled = true;
  }

  setSoundEnabled(v) {
    this.soundEnabled = v;
  }

  _ensureCtx() {
    if (!this.ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      this.ctx = new AC();
    }
    if (this.ctx.state === 'suspended') this.ctx.resume();
    return this.ctx;
  }

  // Call on first user gesture to unlock audio on iOS Safari.
  unlock() {
    const ctx = this._ensureCtx();
    if (ctx && ctx.state === 'suspended') ctx.resume();
  }

  _tone({ freq = 440, dur = 0.15, type = 'sine', gain = 0.2, delay = 0, sweep = 0 }) {
    if (!this.soundEnabled) return;
    const ctx = this._ensureCtx();
    if (!ctx) return;
    const t0 = ctx.currentTime + delay;
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, t0);
    if (sweep) osc.frequency.exponentialRampToValueAtTime(Math.max(1, freq + sweep), t0 + dur);
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(gain, t0 + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    osc.connect(g);
    g.connect(ctx.destination);
    osc.start(t0);
    osc.stop(t0 + dur + 0.02);
  }

  // Soft, woody card slide
  playCard() {
    this._tone({ freq: 320, dur: 0.12, type: 'triangle', gain: 0.18, sweep: -120 });
  }

  // Warm pluck when cards are captured
  capture() {
    this._tone({ freq: 440, dur: 0.1, type: 'sine', gain: 0.2 });
    this._tone({ freq: 660, dur: 0.14, type: 'sine', gain: 0.16, delay: 0.06 });
  }

  select() {
    this._tone({ freq: 620, dur: 0.07, type: 'sine', gain: 0.15 });
  }

  deselect() {
    this._tone({ freq: 380, dur: 0.07, type: 'sine', gain: 0.13 });
  }

  error() {
    this._tone({ freq: 180, dur: 0.16, type: 'sawtooth', gain: 0.12 });
  }

  // Triumphant arpeggio for a Scopa
  scopa() {
    const notes = [523.25, 659.25, 783.99, 1046.5];
    notes.forEach((f, i) =>
      this._tone({ freq: f, dur: 0.22, type: 'triangle', gain: 0.22, delay: i * 0.09 })
    );
  }

  win() {
    const notes = [523.25, 659.25, 783.99, 1046.5, 1318.5];
    notes.forEach((f, i) =>
      this._tone({ freq: f, dur: 0.3, type: 'triangle', gain: 0.2, delay: i * 0.12 })
    );
  }
}

const audioManager = new AudioManager();
export default audioManager;
